/** 発注管理 */
export const BREADCRUMB_ORDER = {
  SELECT_ITEM: '食品選択',
  SELECT_DELIVERY: '届先選択',
  SELECTED: '選択リスト',
  QUANTITY_INPUT: '数量',
};
